import { FC } from "react";
import { useTranslation } from "react-i18next";
import { aggregatedData } from "../../constants";
import ImageWithEmptyFallback from "src/components/ImageWithEmptyFallback/ImageWithEmptyFallback";
import { Link } from "react-router-dom";
import { track } from "@amplitude/analytics-browser";
import { GiftcardItem } from "src/store/slices/item/subitems/giftcards.types";
import { Brand } from "src/store/slices/item/item.type";

type GiftcardProps = Brand<GiftcardItem> & {
  onClick?: () => void;
};

const GiftCard: FC<GiftcardProps> = ({ imageUrl, name, items = [], code }) => {
  const { t } = useTranslation();
  const category = items[0]?.categoriesList?.[0];

  return (
    <Link
      className="font-inter rounded-xs bg-background-default hover:shadow-xs group relative relative overflow-hidden p-3 shadow-sm transition-shadow"
      to={`${code}`}
      onClick={() => track("Card Selected", { code, name, category: category?.name })}
    >
      <div className="flex flex-col items-center justify-center gap-3">
        <div className="flex aspect-square w-full items-center justify-center overflow-hidden rounded-sm">
          <ImageWithEmptyFallback
            src={imageUrl}
            alt={name}
            className="h-full! w-full! object-contain transition-transform duration-300 group-hover:scale-105"
          />
        </div>

        <div className="flex w-full flex-col items-start gap-2">
          <div className="text-font-default w-full truncate text-sm font-medium capitalize md:text-base">{name}</div>
          <div className="flex flex-col items-start justify-start">
            <div className="text-font-subtle text-xs font-medium leading-tight">{t("Giftcards.redemptionCost")}</div>
            <div className="text-font-default text-sm leading-tight md:text-base">{aggregatedData.points.labelTransform(items, t)}</div>
          </div>
        </div>
        {category?.name && (
          <div
            className="rounded-xs! bg-background-hover text-font-active max-w-3/4 absolute right-4 top-4 truncate px-3 py-2 text-right text-xs font-semibold capitalize"
          >
            {category?.name}
          </div>
        )}
      </div>
    </Link>
  );
};

export default GiftCard;
